import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Header } from '../layout/Header';
import { NCEIHeader } from '../layout/NCEIHeader';
import { NCEIFooter } from '../layout/NCEIFooter';
import { About } from './about/About';
import { Hazards } from './hazards/Hazards';
import { Reference } from './reference/Reference';
import { MessageDock } from '../layout/MesageDock';
import { withUser } from '../auth/withUser';
import { withToken } from '../auth/withToken';
import { HelpModalWrapper } from '../modals/HelpModal';
import { Swagger } from './swagger/Swagger';
import { LoggedOut } from './oauth/LoggedOut';
import { CommonDataLoader } from '../CommonDataLoader';

const CheckedHazards = withUser(Hazards);


const ViewUnwrapped = ({
  basePath, history,
}) => (
  <div className="haz-content">
    <HelpModalWrapper>
      <MessageDock />
      <NCEIHeader />
      <Header history={history} />
      <div className="haz-main" id="maincontent">
        <Switch>
          <Route exact path={`${basePath}/about`} component={withUser(About)} />
          <Route path={`${basePath}/hazards`} render={props => (<CommonDataLoader><CheckedHazards {...props} basePath={`${basePath}/hazards`} /></CommonDataLoader>)} />
          <Route path={`${basePath}/reference`} render={props => (<CommonDataLoader><Reference {...props} basePath={`${basePath}/reference`} /></CommonDataLoader>)} />
          <Route exact path={`${basePath}/swagger`} component={withToken(Swagger)} />
          <Route exact path={`${basePath}/loggedout`} component={LoggedOut} />
          <Redirect to={`${basePath}/about`} />
        </Switch>
      </div>
    </HelpModalWrapper>
    <NCEIFooter />
  </div>
);

ViewUnwrapped.propTypes = {
  basePath: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export const View = withUser(ViewUnwrapped);
